export class MenuItem<T> {
	constructor(
		public value: T,
		public text: string,
		public condition: (string) => boolean = null
	) {}
}
